import * as gitRevSync from 'git-rev-sync';

interface VersionControlInfo {
  branchName: string;
  commitDate: string;
  commitId: string;
  commitMessage: string;
  hasUncommittedChanges: boolean;
  repositoryRemoteUrl: string;
  versionControlSystemName: string;
}

export default async function getVersionControlInfo(
  directory: string,
): Promise<Partial<VersionControlInfo>> {
  let result: Partial<VersionControlInfo> = {};

  try {
    const gitCommitHash = gitRevSync.long(directory);

    if (gitCommitHash) {
      result = {
        branchName: gitRevSync.branch(directory),
        commitDate: gitRevSync.date().toISOString(),
        commitId: gitCommitHash,
        commitMessage: gitRevSync.message(),
        hasUncommittedChanges: gitRevSync.isDirty(),
        repositoryRemoteUrl: gitRevSync.remoteUrl(),
        versionControlSystemName: 'git',
      };
    }
  } catch {
    // Ignore
  }

  return result;
}
